import { Component, input } from '@angular/core';
import { TextSlicePipe } from '../../../../pipes/text-slice.pipe';
import { FilesizePipe } from '../../../../pipes/filesize.pipe';
import { PostFile } from '../../../../interfaces';
import { DataTestDirective } from '@outlaw/core';

@Component({
  selector: 'ol-file-item',
  templateUrl: 'file-item.component.html',
  imports: [TextSlicePipe, FilesizePipe, DataTestDirective],
  styleUrl: 'file-item.component.scss',
})
export class FileItemComponent {
  file = input<PostFile>();
  hasAccess = input<boolean>();

  // get isLocked(): boolean {
  //   return !this.file().file_url;
  // }
}
